import { PageHero } from '@/components/ui/PageHero'
import { whiteCoatHerbalist } from '@/assets/siteMedia'

export const ProgrammeHero = () => (
  <PageHero
    image={whiteCoatHerbalist}
    imageAlt="Kandake in a white coat examining fresh herbs beside a laptop and microscope"
    imagePosition="object-[62%_30%]"
    highlights={[
      'Personal 12-week plan',
      'Regular one-to-one reviews',
      'Long-term maintenance plan',
    ]}
    title="3 Month Integrated"
    accent="Health Programme"
    description={
      <>
        <p>
          Designed for people who want more than a one-off consultation or health scan and would
          benefit from structured, ongoing support over three months.
        </p>
        <p className="text-base text-green-100">
          Rather than following a standard protocol, your programme is developed around you: your
          health history, current concerns, diet, lifestyle, nutritional needs, personal
          circumstances and health goals. It is reviewed and adjusted as you progress.
        </p>
      </>
    }
  />
)
